import {ArrowUpRight} from 'lucide-react'
import React from 'react'
import {useIntl} from 'react-intl'

import {AssistantSuggestion} from '../../modes/assistant/assistantResponseContract'

type AssistantSuggestionChipsProps = {
  suggestions: AssistantSuggestion[]
  onSelect: (suggestion: AssistantSuggestion) => void
  disabled?: boolean
}

/**
 * Widening offers under a no-data answer (`meta.suggestions`), each one click instead of a
 * round trip.
 *
 * They arrive structured rather than as a sentence on purpose: the answer agent forbids offer
 * phrasing outright — "shall I…", "would you like me to…" — because an offer instead of an
 * answer is a refusal wearing a helpful face. Rendering these as prose would put that back.
 */
const AssistantSuggestionChips: React.FC<AssistantSuggestionChipsProps> = ({
  suggestions,
  onSelect,
  disabled = false,
}) => {
  const intl = useIntl()

  if (suggestions.length === 0) return null

  return (
    <div className='chatbot-widen'>
      <div className='chatbot-widen__intro'>
        {intl.formatMessage({id: 'CHATBOT.SUGGESTIONS.LABEL'})}
      </div>
      <div
        className='chatbot-widen__options'
        role='list'
        aria-label={intl.formatMessage({id: 'CHATBOT.SUGGESTIONS.ARIA'})}
      >
        {suggestions.map((suggestion) => (
          <button
            key={`${suggestion.label}-${suggestion.query}`}
            type='button'
            role='listitem'
            className='chatbot-widen__option'
            disabled={disabled}
            onClick={() => onSelect(suggestion)}
            title={suggestion.query}
          >
            <span>{suggestion.label}</span>
            <ArrowUpRight size={14} aria-hidden='true' />
          </button>
        ))}
      </div>
    </div>
  )
}

export default AssistantSuggestionChips
